var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellularConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.666626H15C14.4477 0.666626 14 1.11434 14 1.66663V10.3333C14 10.8856 14.4477 11.3333 15 11.3333H16C16.5523 11.3333 17 10.8856 17 10.3333V1.66663C17 1.11434 16.5523 0.666626 16 0.666626ZM10.3333 2.99996H11.3333C11.8856 2.99996 12.3333 3.44767 12.3333 3.99996V10.3333C12.3333 10.8856 11.8856 11.3333 11.3333 11.3333H10.3333C9.78105 11.3333 9.33333 10.8856 9.33333 10.3333V3.99996C9.33333 3.44767 9.78105 2.99996 10.3333 2.99996ZM6.66667 5.33329H5.66667C5.11438 5.33329 4.66667 5.78101 4.66667 6.33329V10.3333C4.66667 10.8856 5.11438 11.3333 5.66667 11.3333H6.66667C7.21895 11.3333 7.66667 10.8856 7.66667 10.3333V6.33329C7.66667 5.78101 7.21895 5.33329 6.66667 5.33329ZM2 7.33329H1C0.447715 7.33329 0 7.78101 0 8.33329V10.3333C0 10.8856 0.447715 11.3333 1 11.3333H2C2.55228 11.3333 3 10.8856 3 10.3333V8.33329C3 7.78101 2.55228 7.33329 2 7.33329Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellularConnection);
export default __webpack_public_path__ + "static/media/CellularConnection.24f954f2cdea3d4519a590550b3871bb.svg";
export { ForwardRef as ReactComponent };